import React from 'react';
import HomePageLayout from '../components/homePageLayout/homePageLayout';

const IndexPage = () => (
	<HomePageLayout>
	</HomePageLayout>
);

export default IndexPage;
